
import { renderMessages } from './utils'

const ErrorAlert = ({errorData, setErrorData}) => {
    return (
        <>
            {errorData !== null && errorData.status !== null ? (
                renderMessages(errorData.messages, setErrorData)
            ) : (
                <div />
            )}
        </>
    );
};


export default ErrorAlert;